// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/connector/v2/asset.proto" (package "c1.connector.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.connector.v2.AssetRef
 */
export interface AssetRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.connector.v2.AssetServiceGetAssetRequest
 */
export interface AssetServiceGetAssetRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.AssetRef asset = 1;
     */
    asset?: AssetRef;
}
/**
 * @generated from protobuf message c1.connector.v2.AssetServiceGetAssetResponse
 */
export interface AssetServiceGetAssetResponse {
    /**
     * @generated from protobuf oneof: msg
     */
    msg: {
        oneofKind: "metadata";
        /**
         * @generated from protobuf field: c1.connector.v2.AssetServiceGetAssetResponse.Metadata metadata = 1;
         */
        metadata: AssetServiceGetAssetResponse_Metadata;
    } | {
        oneofKind: "data";
        /**
         * @generated from protobuf field: c1.connector.v2.AssetServiceGetAssetResponse.Data data = 2;
         */
        data: AssetServiceGetAssetResponse_Data;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.connector.v2.AssetServiceGetAssetResponse.Metadata
 */
export interface AssetServiceGetAssetResponse_Metadata {
    /**
     * @generated from protobuf field: string content_type = 1;
     */
    contentType: string;
}
/**
 * @generated from protobuf message c1.connector.v2.AssetServiceGetAssetResponse.Data
 */
export interface AssetServiceGetAssetResponse_Data {
    /**
     * @generated from protobuf field: bytes data = 1;
     */
    data: Uint8Array;
}
// @generated message type with reflection information, may provide speed optimized methods
class AssetRef$Type extends MessageType<AssetRef> {
    constructor() {
        super("c1.connector.v2.AssetRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetRef
 */
export const AssetRef = new AssetRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetServiceGetAssetRequest$Type extends MessageType<AssetServiceGetAssetRequest> {
    constructor() {
        super("c1.connector.v2.AssetServiceGetAssetRequest", [
            { no: 1, name: "asset", kind: "message", T: () => AssetRef, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetServiceGetAssetRequest
 */
export const AssetServiceGetAssetRequest = new AssetServiceGetAssetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetServiceGetAssetResponse$Type extends MessageType<AssetServiceGetAssetResponse> {
    constructor() {
        super("c1.connector.v2.AssetServiceGetAssetResponse", [
            { no: 1, name: "metadata", kind: "message", oneof: "msg", T: () => AssetServiceGetAssetResponse_Metadata },
            { no: 2, name: "data", kind: "message", oneof: "msg", T: () => AssetServiceGetAssetResponse_Data }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetServiceGetAssetResponse
 */
export const AssetServiceGetAssetResponse = new AssetServiceGetAssetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetServiceGetAssetResponse_Metadata$Type extends MessageType<AssetServiceGetAssetResponse_Metadata> {
    constructor() {
        super("c1.connector.v2.AssetServiceGetAssetResponse.Metadata", [
            { no: 1, name: "content_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "256" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetServiceGetAssetResponse.Metadata
 */
export const AssetServiceGetAssetResponse_Metadata = new AssetServiceGetAssetResponse_Metadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AssetServiceGetAssetResponse_Data$Type extends MessageType<AssetServiceGetAssetResponse_Data> {
    constructor() {
        super("c1.connector.v2.AssetServiceGetAssetResponse.Data", [
            { no: 1, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "0", maxLen: "1048576" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AssetServiceGetAssetResponse.Data
 */
export const AssetServiceGetAssetResponse_Data = new AssetServiceGetAssetResponse_Data$Type();
/**
 * @generated ServiceType for protobuf service c1.connector.v2.AssetService
 */
export const AssetService = new ServiceType("c1.connector.v2.AssetService", [
    { name: "GetAsset", serverStreaming: true, options: {}, I: AssetServiceGetAssetRequest, O: AssetServiceGetAssetResponse }
]);
